/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { ReactElement, ReactNode, createContext, useContext } from 'react';
import { SharedDataJson } from '../services/DataSharingService';

const DataSharingContext = createContext<SharedDataJson | undefined>(undefined);

type DataStoreProps = {
  value: SharedDataJson;
  children: ReactNode;
};
const DataSharingProvider = ({ value, children }: DataStoreProps): ReactElement => (
  <DataSharingContext.Provider value={value}>{children}</DataSharingContext.Provider>
);

type DataSharingProps = {
  setData(data: any): void;
  getData(): any;
};

export const useDataShareStore = (): DataSharingProps => {
  const shareDataService = useContext(DataSharingContext);
  if (!shareDataService) {
    throw new Error('"Use store data" must be used within the StoreData Provider.');
  }
  const { setData, getData } = shareDataService;
  return { setData, getData };
};
export default DataSharingProvider;
